<template>
  <ConfirmationModal
    :title="$t('DELETE_PREDICTIVE_ROUTING_CONFIG_CONFIRMATION_TITLE')"
    :entity="predictiveRoutingConfig"
    :show-confirm-button="true"
    :show-cancel-button="true"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-disabled="disableModalConfirm"
    :confirm-button-loading="deletingPredictiveRoutingConfig"
    @close="closeModal"
    @confirm="deletePredictiveRoutingConfig"
  >
    <div>
      <p v-html="$t('DELETE_PREDICTIVE_ROUTING_CONFIG_MODAL_TEXT', { predictiveRoutingConfigToDeleteName })">
      </p>
      <div class="form-horizontal m-l-10 m-r-10">
        <div class="checkbox">
          <label>
            <input
              type="checkbox"
              v-model="forceDelete"
              @change="attestDelete"
            />
            <span v-t="'DELETE_PREDICTIVE_ROUTING_CONFIG_ATTEST_NONE'"></span>
          </label>
        </div>
      </div>
    </div>

  </ConfirmationModal>
</template>

<script>
import { mapGetters } from 'vuex';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';

export default {
  name: 'PredictiveRoutingConfigDeleteModal',
  components: {
    ConfirmationModal
  },
  props:{
    predictiveRoutingConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    disableModalConfirm: {
      type: Boolean,
      default: false
    },
    deletingPredictiveRoutingConfig: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      forceDelete: false,
    };
  },
  computed: {
    predictiveRoutingConfigToDeleteName() {
      return this.predictiveRoutingConfig?.name;
    }
  },
  methods:{
    closeModal() {
      this.$emit('closeModal');
    },
    deletePredictiveRoutingConfig() {
      this.$emit('deletePredictiveRoutingConfig', this.predictiveRoutingConfig);
    },
    attestDelete() {
      this.$emit('attestDelete', this.forceDelete);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>